import { useFormik } from "formik";
import * as Yup from "yup";

const useFormDevice = (onSubmit, afterSubmit, initialValues, isEditMode) => {
  const validationSchema = Yup.object({
    commerceId: Yup.number()
      .required("El comercio es requerido")
      .typeError("El comercio es requerido"),
    zoneId: Yup.number().required("La zona es requerida").typeError("La zona es requerida"),
    nomenclature: Yup.string().required("El nombre de la zona es requerido").trim(),
    description: Yup.string().required("La descripción es requerida").trim(),
    status: Yup.boolean().required("El estado es requerido"),
  });

  const safeInitialValues = {
    commerceId: "",
    zoneId: "",
    nomenclature: "",
    description: "",
    status: true,
    ...initialValues,
  };

  return useFormik({
    initialValues: safeInitialValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        await onSubmit(values);
        afterSubmit();
      } finally {
        setSubmitting(false);
      }
    },
  });
};

export default useFormDevice;
